import React from 'react';
import { t, Trans } from '@lingui/macro';
import { HStack, Progress, Text } from '@chakra-ui/react';
import { useLocalisation } from '../../../helpers/i18n/use-localisation';

export const useValidationCapsule = (validation) => {
  if (!validation || !validation.sectionResults) {
    return {
      supportingText: null,
      score: null,
      borderColor: null
    };
  }
  const { i18n } = useLocalisation();
  let numTotalParts = 0;
  let numPartsCorrect = 0;
  let supportingText;
  let borderColor;
  let progressColor;
  Object.entries(validation.sectionResults).forEach(([key, value]) => {
    if (validation.validations[key] && validation.validations[key].options.unmarked) {
      return;
    }
    numTotalParts += 1;
    if (Array.isArray(value)) {
      if (value.every(Boolean)) {
        numPartsCorrect += 1;
      }
    } else if (typeof value === 'object') {
      if (Object.values(value).every(tool => tool.every(Boolean))) {
        numPartsCorrect += 1;
      }
    } else if (value) {
      numPartsCorrect += 1;
    }
  });
  const percentageCorrect = Math.ceil((numPartsCorrect / numTotalParts) * 100);

  if (percentageCorrect >= 80) {
    supportingText = i18n._(t`Impressive work! Keep shining.`);
    borderColor = '#58D25B';
    progressColor = '#58D25B';
  } else if (percentageCorrect >= 50) {
    supportingText = i18n._(t`Well done! You're making great progress— Keep aiming high!`);
    borderColor = '#F7D064';
    progressColor = '#FEE8AD';
  } else {
    supportingText = i18n._(t`Every challenge helps you grow—keep going and give it another try!`);
    borderColor = '#F0939B';
    progressColor = '#FBDFE1';
  }

  return {
    supportingText: (
      <Text fontSize={{ base: '22px', mle: '30px' }}>{supportingText}</Text>
    ),
    score: (
      <HStack>
        <Text fontSize="20px" color="#5C6C7F">
          <Trans>SCORE</Trans>:
        </Text>
        <Text fontSize="20px" color="#001937" fontWeight="700">{numPartsCorrect}/{numTotalParts}</Text>
        <Progress value={percentageCorrect} colorScheme={progressColor} w="160px" h="20px" top="3px" />
        <Text fontSize="30px" color="#001937" fontWeight="700">{percentageCorrect}%</Text>
      </HStack>
    ),
    borderColor
  };
};
